import { useEffect, useState, useContext } from 'react';
import { Query } from '../../../utils/query';
import { Order } from '../../../utils/table';
import { SearchSortContext } from '../../../context/SearchSortContext';
import {
  ChangeSearchPayload,
  PageSearchSortContextActionType,
} from '../../../context/types';
import parseUrlFilterSearch from '../../../hooks/parseUrlFilterSearch';
import useUrlFilterSearch from '../../../hooks/useUrlFilterSearch';
import { UrlParam } from '../../../redux/types/filter';
import { Webhook } from '../../../redux/types/webhooks';

const useWebhooks = (
  loadWebhooks: (query: Query & { builderId: number }) => void,
  builderId: number
) => {
  const urlParse = parseUrlFilterSearch<UrlParam>();
  const {
    dispatch,
    state: { webhooks },
  } = useContext(SearchSortContext);
  const {
    currentOrderBy,
    currentOrder,
    currentPage,
    rowsPerPageAmount,
    contextSearch,
  } = webhooks;

  const [search, setSearch] = useState<string>(
    urlParse.search || contextSearch,
  );
  const [order, setOrder] = useState<Order>(urlParse.order || currentOrder);
  const [orderBy, setOrderBy] = useState<keyof Webhook>(
    urlParse.orderBy || currentOrderBy,
  );
  const [page, setPage] = useState<number>(urlParse.page || currentPage);
  const [rowsPerPage, setRowsPerPage] = useState<number>(
    urlParse.limit || rowsPerPageAmount,
  );

  useUrlFilterSearch<UrlParam>({
    search,
    order,
    orderBy,
    page: String(page),
    limit: rowsPerPage,
  });

  const dispatchWebhooks = (
    type: PageSearchSortContextActionType<'CHANGE_WEBHOOK'>,
    payload?: ChangeSearchPayload<Webhook>,
  ) => dispatch({ type, payload: { ...webhooks, ...payload } });

  useEffect(() => {
    loadWebhooks({
      search,
      order,
      orderBy,
      page: String(page),
      limit: rowsPerPage,
      builderId,
    });
  }, [
    order,
    orderBy,
    page,
    rowsPerPage,
    search,
    loadWebhooks,
    builderId
  ]);

  return {
    order,
    orderBy,
    page,
    search,
    rowsPerPage,
    setSearch,
    setOrder,
    setOrderBy,
    setPage,
    setRowsPerPage,
    dispatchWebhooks,
  };
};

export default useWebhooks;
